var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTbs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 23.97 9.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #82c655;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.24,.13V1.96h-2.48v7.53H2.48V1.96H0V.13H7.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.36,5.5c.33,.42,.49,.9,.49,1.45,0,.78-.27,1.4-.82,1.86-.55,.46-1.31,.69-2.29,.69h-4.36V.13h4.21c.95,0,1.7,.22,2.23,.65,.54,.44,.81,1.03,.81,1.77,0,.55-.14,1.01-.43,1.37-.29,.36-.67,.62-1.15,.76,.54,.12,.98,.38,1.31,.81Zm-4.69-1.58h1.49c.37,0,.66-.08,.86-.25s.3-.41,.3-.73-.1-.56-.3-.73-.49-.25-.86-.25h-1.49v1.96Zm2.57,3.47c.21-.17,.31-.42,.31-.75s-.11-.59-.33-.77c-.22-.19-.52-.28-.9-.28h-1.65v2.07h1.68c.38,0,.68-.09,.89-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.72,9.25c-.54-.22-.98-.55-1.3-.99-.32-.44-.5-.96-.51-1.57h2.43c.04,.35,.16,.61,.36,.79,.21,.18,.47,.27,.8,.27s.6-.08,.8-.23c.2-.16,.29-.37,.29-.65,0-.23-.08-.42-.23-.57-.16-.15-.35-.28-.57-.37-.23-.1-.55-.21-.97-.33-.61-.19-1.1-.37-1.48-.56-.38-.19-.71-.46-.99-.83-.28-.36-.41-.84-.41-1.43,0-.87,.32-1.55,.95-2.05,.63-.49,1.45-.74,2.47-.74s1.86,.25,2.49,.74c.63,.49,.97,1.18,1.01,2.06h-2.47c-.02-.3-.13-.54-.33-.71s-.47-.26-.79-.26c-.28,0-.5,.07-.67,.22-.17,.15-.25,.36-.25,.63,0,.3,.14,.54,.43,.71,.29,.17,.73,.35,1.33,.55,.6,.2,1.1,.4,1.47,.59,.38,.19,.71,.46,.98,.81,.28,.36,.41,.81,.41,1.37s-.14,1.02-.41,1.45c-.27,.44-.67,.78-1.18,1.04s-1.12,.39-1.83,.39-1.3-.11-1.84-.33Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTbs);
export default __webpack_public_path__ + "static/media/tbs.f8852f283bf63e7cb42280e4514903b3.svg";
export { ForwardRef as ReactComponent };